import { sortBy } from 'lodash';
import { DailySchedule } from '@/modules/Schedule';
import Repository from './client/TbsJsonAxiosClient';

const resource = '/schedule';

export const useScheduleRepository = () => {
  /**
   * 指定年月の番組表情報JSONを取得する
   * @param date YYYYMM
   */
  const get = async (date: string) => {
    const { data } = await Repository.get<{ schedule: Record<string, DailySchedule> }>(
      `${resource}/${date}.json`
    ).catch((e) => {
      if (e?.response?.status === 403) {
        return { data: { schedule: null } };
      } else {
        throw e;
      }
    });

    // 取得した番組一覧を開始時間順でソート
    if (data.schedule) {
      for (const date of Object.keys(data.schedule)) {
        data.schedule[date] = {
          tch1: sortBy(data.schedule[date].tch1, 'start'),
          tch2: sortBy(data.schedule[date].tch2, 'start'),
        };
      }
    }

    return data;
  };

  /**
   * 指定年月の番組表情報JSONを並列処理で取得する
   * @param dateArray [YYYYMM, YYYYMM, ...]
   */
  const bulkGet = async (dateArray: string[]) => {
    return Promise.all(dateArray.map(get)).catch((e) => {
      throw e;
    });
  };

  return {
    get,
    bulkGet,
  };
};

export type ScheduleRepository = ReturnType<typeof useScheduleRepository>;
